export default __webpack_public_path__ + "static/media/sports_btn.e756420a.png";